<script lang="ts">
  import Table from './Table.svelte';
  import Section from './Section.svelte';
  import Form from './Form.svelte';
  import FlexibleDataModelType from '$provider/lib/apis/models/FlexibleDataModelType';

  interface Props {
    value?: any;
    title?: string;
    showBg?: boolean;
  }

  let { value = {}, title = '', showBg = false }: Props = $props();
</script>

<div class="complex-obj">
  {#if title}
    <div data-cy={`${title}-header`} class="title">{title}</div>
  {/if}
  {#if value?.type === FlexibleDataModelType.Form}
    <Form {showBg} data={value.data} />
  {:else if value?.type === FlexibleDataModelType.Table}
    <Table data={value.data} />
  {:else if value?.type === FlexibleDataModelType.Section}
    <Section data={value.data} />
  {:else}
    <div class="empty">No Data Found</div>
  {/if}
</div>

<style>
  .complex-obj {
    width: 100%;
  }
  .title {
    font-weight: bold;
    font-size: 14px;
    line-height: 17px;
    color: var(--black);
    margin: 16px;
  }
</style>
